module.exports = __webpack_public_path__ + "img/card-b2.adefc990.png";